/** Key names as each platform spells them (Kbd card). */
export const keyLabels = {
  apple: { cmd: '⌘', ctrl: '⌃', alt: '⌥', shift: '⇧' },
  other: { cmd: 'Ctrl', ctrl: 'Ctrl', alt: 'Alt', shift: 'Shift' },
  common: {
    enter: '↵',
    up: '↑',
    down: '↓',
    left: '←',
    right: '→',
    esc: 'Esc',
    tab: 'Tab',
    space: 'Space',
  },
} as const
